import Vue from 'vue';
import axios from 'axios';
import router from '../router';
import { Message } from 'element-ui';

export default function(injection, Vue) {
  const global = {};

  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

  axios.interceptors.response.use(
    response => response,
    error => {
      try {
        const statusCode = error.response.status;
        // alert(statusCode)
        decJobs();
        if (statusCode === 401) {
          // if (injection.util.browser().mobile) {
          //     mobileLogin();
          // } else {
          window.location.href = injection.config.webUrl.logout;
          // }
          // 请先登录
        } else if (statusCode === 422) {
          // 参数有误
          return Promise.reject(error.response.data);
        }
        return Promise.reject(error.response.data);
      } catch (e) {
        return Promise.reject({
          errcode: '0000',
          errmessage: '出错'
        });
      }
    }
  );

  const triggerMap = {};

  const presets = {};

  let _loadingDom = null;
  let _jobsCount = 0;

  const incJobs = function() {
    _jobsCount += 1;
  };

  const apiGateway = function(api, data) {
    return apiFunc.apply(apiGateway, arguments);
  };

  const apiFunc = function(api, data, options = {}) {
    const tgOptions = {
      url: api,
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      data: modifyArguments(data)
    };

    // 非登录接口在请求头Authorization中带上'Bearer '加access_token
    // if (api.toString() !== injection.config.apiUrl.ucLogin) {
    //     const token = injection.store.state.token || sessionStorage.getItem('token');
    //     tgOptions.headers['Authorization'] = ('Bearer ' + token).replace(/"/g, '');
    // }

    Object.keys(options).forEach(x => {
      if (typeof tgOptions[x] === 'object') {
        Object.keys(options[x]).forEach(v => {
          tgOptions[x][v] = options[x][v];
        });
      } else {
        tgOptions[x] = options[x];
      }
    });

    if (tgOptions.method.toLocaleLowerCase() === 'get') {
      tgOptions['params'] = tgOptions['data'];
    }
    incJobs();

    return axios
      .request(tgOptions)
      .then(function(response) {
        if (response.data.code == 10401) {
          Message.error({
            message: '您还未登录或当前登录状态已失效，请重新登录系统',
            onClose: function() {
              sessionStorage.clear();
              router.replace({
                path: 'login',
                query: { redirect: router.currentRoute.fullPath }
              });
            }
          });

          return false;
        } else if (response.data.code !== 200) {
          return Promise.reject(response.data);
        } else {
          if (response.data && 'trigger' in response.data) {
            if (response.data.trigger in triggerMap) {
              triggerMap[response.data.trigger].forEach(x => {
                x.call(apiGateway, response.data.data, api, data);
              });
            }
          } else if (response.data.code == 200) {
            return Promise.resolve(response.data.data);
          }
        }
      })
      .catch(error => {
        return Promise.reject(error);
      });
  };

  /* 格式化参数 */
  const modifyArguments = function(data) {
    if (!(data instanceof Object)) {
      return data;
    }
    Object.keys(presets).forEach(x => {
      if (!(x in data)) {
        data[x] = presets[x];
      }
    });
    let hasFile = false;
    Object.keys(data).forEach(x => {
      if (data[x] instanceof window.File) {
        hasFile = true;
      } else if (data[x] instanceof window.Blob) {
        hasFile = true;
      }
    });
    if (hasFile) {
      let formData = new FormData();
      Object.keys(data).forEach(x => {
        formData.append(x, data[x]);
      });
      return formData;
    }
    return data;
  };

  apiGateway.setTrigger = function(trigger, func) {
    if (trigger in triggerMap) {
      triggerMap[trigger].push(func);
    } else {
      triggerMap[trigger] = [func];
    }
    return apiGateway;
  };

  apiGateway.preset = function(key, value) {
    presets[key] = value;
  };

  Object.defineProperties(Vue.prototype, {
    $api: {
      get() {
        return apiGateway;
      }
    },
    $http: {
      get() {
        return axios;
      }
    }
  });

  Object.defineProperties(injection, {
    http: {
      get() {
        return axios;
      }
    },
    api: {
      get() {
        return apiGateway;
      }
    }
  });

  Object.defineProperties(Vue, {
    http: {
      get() {
        return axios;
      }
    }
  });
}
